import React, { useState } from "react";
import { toast } from "sonner";
import api from "../../lib/api";

export const DURATIONS = [
  { label: "1 hour", minutes: 60 },
  { label: "24 hours", minutes: 1440 },
  { label: "7 days", minutes: 10080 },
  { label: "30 days", minutes: 43200 },
  { label: "Permanent", minutes: null },
];

export const fmtUntil = (r) => (r?.until ? `until ${new Date(r.until).toLocaleString()}` : "permanently");

export const callAdmin = async (method, url, data, okMsg) => {
  try {
    const r = await api.request({ method, url: `/admin${url}`, data });
    if (okMsg) toast.success(okMsg);
    return r.data;
  } catch (e) {
    const d = e.response?.data?.detail;
    toast.error(typeof d === "string" ? d : "Action failed");
    return null;
  }
};

// Duration picker + reason + apply button, used for account locks and chat bans.
export function RestrictForm({ testId, label, onApply }) {
  const [minutes, setMinutes] = useState(1440);
  const [reason, setReason] = useState("");
  const [busy, setBusy] = useState(false);
  const apply = async () => {
    setBusy(true);
    await onApply({ minutes, reason });
    setBusy(false);
    setReason("");
  };
  return (
    <div className="flex flex-wrap items-center gap-2" data-testid={`${testId}-form`}>
      <select
        data-testid={`${testId}-duration`}
        value={minutes === null ? "perm" : String(minutes)}
        onChange={(e) => setMinutes(e.target.value === "perm" ? null : Number(e.target.value))}
        className="px-2 py-1.5 rounded-lg bg-[#0A051A] border border-[#00F0FF]/40 font-mono text-xs"
      >
        {DURATIONS.map(d => <option key={d.label} value={d.minutes === null ? "perm" : d.minutes}>{d.label}</option>)}
      </select>
      <input
        data-testid={`${testId}-reason`}
        value={reason}
        maxLength={300}
        onChange={(e) => setReason(e.target.value)}
        placeholder="Reason (shown to the player)"
        className="flex-1 min-w-[180px] px-2 py-1.5 rounded-lg bg-[#0A051A] border border-[#00F0FF]/40 font-mono text-xs outline-none focus:border-[#00F0FF]"
      />
      <button data-testid={`${testId}-apply`} disabled={busy} onClick={apply}
        className="px-3 py-1.5 rounded-lg border border-[#FF007F] text-[#FF007F] hover:bg-[#FF007F]/15 font-heading text-xs uppercase tracking-widest disabled:opacity-50">
        {label}
      </button>
    </div>
  );
}
